"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const graphql_1 = require("../..");
exports.workflowRuns = graphql_tag_1.default `
  query workflowRunsQuery(
    $skip: Int,
    $take: Int,
    $workflowId: ID,
    $orderBy: String,
    $orderDir: String
    $archivedWorkflows: Boolean,
    $after: String,
    $before: String
  ) {
    workflowRunCount(
      workflowId: $workflowId,
      after: $after,
      before: $before,
      archivedWorkflows: $archivedWorkflows
    )
    workflowRuns(
      workflowId: $workflowId,
      skip: $skip,
      take: $take,
      orderBy: $orderBy,
      orderDir: $orderDir,
      archivedWorkflows: $archivedWorkflows,
      after: $after,
      before: $before
    ) {
      ...workflowRunDetailData
    }
  }
  ${graphql_1.workflowRunDetailData}
`;
exports.workflowRun = graphql_tag_1.default `
  query workflowRun(
    $id: ID!
  ) {
    workflowRun(
      id: $id
    ) {
      ...workflowRunDetailData
    }
  }
  ${graphql_1.workflowRunDetailData}
`;
exports.workflowRunExpanded = graphql_tag_1.default `
  query workflowRun(
    $id: ID!
  ) {
    workflowRun(
      id: $id
    ) {
      ...workflowRunExpandedDetailData
    }
  }
  ${graphql_1.workflowRunExpandedDetailData}
`;
exports.workflowRunExpandedWithHtml = graphql_tag_1.default `
  query workflowRun(
    $id: ID!
  ) {
    workflowRun(
      id: $id
    ) {
      ...workflowRunExpandedDetailDataWithHtml
    }
  }
  ${graphql_1.workflowRunExpandedDetailDataWithHtml}
`;
//# sourceMappingURL=workflowRuns.js.map